import { CONSENT_ACTION, CONSENT_STORAGE_KEY } from '../../constants'
import { updateAnalyticsConsentUtil } from '../../utils/update-analytics-consent'
import { logUtil } from 'packages/src'

export const denyAllConsentAction = () => {
  return (dispatch) => {
    const logger = logUtil('consent:denyAll')
    logger.info('User rejected all cookies')

    const consentData = {
      analytics: false,
      marketing: false,
      preferences: false,
      timestamp: new Date().toISOString()
    }

    // Store in localStorage
    try {
      if (window.localStorage) {
        window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consentData))
        logger.debug('Consent preferences saved to localStorage')
      } else {
        logger.warn('localStorage not available, consent will not persist')
      }
    } catch (error) {
      logger.error('Failed to save consent preferences:', error)
    }

    // Update analytics tools
    updateAnalyticsConsentUtil({
      analytics: false,
      marketing: false,
      preferences: false
    })

    dispatch({
      type: CONSENT_ACTION.DENY_ALL
    })
    logger.info('DENY_ALL action dispatched')
  }
}
